import { render, staticRenderFns } from "./UserPermissionTable.vue?vue&type=template&id=16bf8841&scoped=true&"
import script from "./UserPermissionTable.vue?vue&type=script&lang=js&"
export * from "./UserPermissionTable.vue?vue&type=script&lang=js&"
import style0 from "./UserPermissionTable.vue?vue&type=style&index=0&id=16bf8841&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16bf8841",
  null
  
)

export default component.exports